'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ga = exports.ec = exports.setDeviceType = exports.setUserId = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _MixPanel = require('components/MixPanel/MixPanel');

var _SnowplowTracker = require('components/SnowplowTracker/SnowplowTracker');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userId = void 0;
var deviceType = void 0;
var setUserId = exports.setUserId = function setUserId(id) {
  return userId = id;
};
var setDeviceType = exports.setDeviceType = function setDeviceType(type) {
  return deviceType = type;
};

var ec = exports.ec = function ec() {
  (0, _SnowplowTracker.trackUnstruct)(arguments.length >= 1 && (arguments.length <= 0 ? undefined : arguments[0]) ? arguments.length <= 0 ? undefined : arguments[0] : '', (0, _extends3.default)({
    app_platform: 'web'
  }, arguments.length >= 2 && (arguments.length <= 1 ? undefined : arguments[1]) ? arguments.length <= 1 ? undefined : arguments[1] : {}, userId ? { user_id: String(userId) } : {}, deviceType ? { device_type: deviceType } : {}));
  _MixPanel.mixpanel.track.apply(_MixPanel.mixpanel, arguments);
};

var ga = exports.ga = function ga(eventCategory, eventAction) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var eventLabel = args[0],
      eventValue = args[1],
      options = args[2];

  (0, _GoogleTagManager.trackGoogleTagManagerEvent)({
    event: 'gaEvent',
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: eventValue || 0,
    eventNI: options && options.nonInteraction || false
  });

  (0, _SnowplowTracker.trackUnstruct)(eventCategory + ' - ' + eventAction, (0, _extends3.default)({
    app_platform: 'web'
  }, args.length >= 1 && args[0] ? { eventLabel: args[0] } : {}, args.length >= 2 && args[1] ? { eventValue: args[1] } : {}, args.length >= 3 && args[2] && args[2].nonInteraction ? { nonInteraction: true } : {}, userId ? { user_id: String(userId) } : {}));
};